module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box invest-with-us"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Frequently asked questions")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Quick answers to the most asked questions")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Investor Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("The loan officer could see how profitable we are. But even with three great years of business our bank won’t look beyond our credit score.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(9)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("American Credit: the difference you can trust")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(11)])])]), _vm._v(" "), _vm._m(12)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Try us now. See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "invest-with-us-main-img",
    attrs: {
      "src": require("../assets/imgs/american_credit_faq.png"),
      "alt": "american credit faq"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row platform-for-success"
  }, [_c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container platform-for-success-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_faq_1.png"),
      "alt": "American Credit FAQ icon 1"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-title"
  }, [_vm._v("Are you a bank or a mortgage broker?")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_faq_2.png"),
      "alt": "American Credit FAQ icon 2"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-title"
  }, [_vm._v("Am I eligible?")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_faq_3.png"),
      "alt": "American Credit FAQ icon 3"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-title"
  }, [_vm._v("What happens after the online application?")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform faq-questions"
  }, [_c('div', {
    staticClass: "row faq-question-list"
  }, [_c('h2', {
    staticClass: "col-12 col-lg-10 offset-lg-1 faq-question-title"
  }, [_vm._v("About American Credits")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Who, exactly, is American Credit?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("American Credit is fully accredited as a Licensed Lender (California Finance Lender Law License # 60DBO-78243). Our mission is to ensure that no business owner is left behind when they seek the capital needed to fund and grow their businesses.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("What kind of advantages does American Credit offer businesses?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Access to capital has been cited by many business owners as the biggest barrier to expanding their businesses. Our mission is to offer them the capital they need, either through asset-based financing or account receivables (invoice) financing. Funds are available with transparent fees, terms and competitive rates.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Hidden fees can really cost you. Will your rates and terms be fully explained?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Yes, our rates and terms will be clearly stated in your loan offer and your Business Financing Assistant will be available to discuss them before you accept our offer. Plus, our rates are low and fixed, their ranges clearly specified and completely transparent.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("How are your fees/installment calculated?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("For asset-based Loans, there is a one-time origination fee. The monthly installment is calculated with loan amount and a fixed interest rate. All these numbers are listed in the loan agreement before you accept them with your signature. For invoice/AR financing, there is a one-time 2% setup fee to evaluate customer (the ultimate debtor) to the first invoice. The factoring fee is 2%/month (around 0.065% daily factoring fee).")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Are there prepayment penalty fees?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("For an asset-based Loan with a term over 12 months, a prepayment penalty may apply (and be specified in the loan agreement). As for invoice factoring, the factoring fee is based on the actual days before your customer pays it off; and there is no pre-payment penalty.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Are American Credit loans secured?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Yes. Both asset-based Loans and invoice factoring are backed by the collaterals (equipment, account receivables, etc). The loan rate (or factoring fee rate) is significantly lower those high APR unsecured loans.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row faq-question-list"
  }, [_c('h2', {
    staticClass: "col-12 col-lg-10 offset-lg-1 faq-question-title"
  }, [_vm._v("Applying for a loan")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("How do I apply? How long will it take?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Just click here to "), _c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("apply now")]), _vm._v(". You can finish the application in minutes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Will applying for a loan with American Credit affect my credit score?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("No. Applying for a loan with American Credit DOES NOT affect your credit score—our “soft inquiry” of the business owner’s credit won’t lower your score.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Who will you loan to and what credit score is needed to qualify for an Asset-based Loan or invoice factoring?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Our minimum requirements for asset-based loans and invoice factoring are 1 year in business, $150,000 a year in revenue (or $12,500 a month for the last two months). The business owners' (with 25% or more share) personal FICO scores need to be 600 or higher.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("What does it cost to apply for a business loan with American Credit?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Nothing. Your investment in time (maybe 10 minutes) is all we ask.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Does it matter if I apply from my smartphone instead of my computer?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Not at all. In fact, applying from your smartphone may be even easier, since we require a scan or photo of legal ID with your picture on it—and our app conveniently includes a photo taken with a phone’s camera in your application.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row faq-question-list"
  }, [_c('h2', {
    staticClass: "col-12 col-lg-10 offset-lg-1 faq-question-title"
  }, [_vm._v("Loan types and terms")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Do you require a personal guarantee?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("No. American Credit business loan agreements do not require business owners' personal guarantees.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("What are the minimum and maximum amounts I can borrow?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("American Credit Asset-based Loans are available between $20,000 to $5M; and up to 72 months. The invoice financing is available between $5,000 to $2.5M.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("What kind of business loan types does American Credit offer?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("American Credit offers two business financing options:"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("• Asset-based Loans with a maximum borrowing limit of $5M.")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("• Invoice factoring - exchange outstanding invoices for cash equivalents up to $2.5M.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("What kind of business loan terms does American Credit offer?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Asset-based Loans terms vary between 12 to 72 months to fit borrowers’ need. Invoice factoring is typically short-term, such as 30, 60, or 90 days.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Can we get any tax benefit to purchase an equipment with the loan?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Yes. Section 179 of the IRS tax code allows businesses to deduct the full purchase price of qualifying equipment purchased or financed during the tax year, up to $1,000,000.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row faq-question-list",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('h2', {
    staticClass: "col-12 col-lg-10 offset-lg-1 faq-question-title"
  }, [_vm._v("Security")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Do you share the information I provide you with other lenders or businesses?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("No. Never, unless we explicitly ask for your permission and you consent to it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("How secure is the information I share with you?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Your security is our top priority. We follow all information security practices required by law to maintain the integrity of your information, meaning we comply with all industry regulations and use best practice security protocols. Plus, your information is encrypted and vaulted on a server with highly restricted access.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("Why do I have to provide my bank account information?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Because we use it to determine your eligibility for a loan and the amount, and the terms and fees we may offer.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 faq-question-item"
  }, [_c('div', {
    staticClass: "hover-element"
  }, [_c('div', {
    staticClass: "row faq-question-item-wrapper"
  }, [_c('p', {
    staticClass: "col-10"
  }, [_vm._v("How secure is my American Credit account?")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down col-1 offset-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("Your security is our top priority. American Credit complies with all industry regulations and uses best practice security protocols. All your sensitive information is encrypted—and is vaulted on a server with highly restricted access.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center invest-with-us-text"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("Always feel free to call or email us with any questions.")]), _c('br'), _c('br'), _vm._v("\n          American Credit business loan specialists are happy to help with any queries you may have about applying, rates, potential ROI, loan types, our company, fees, security... anything relating to how we can help your business grow.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center invest-with-us-text"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("Call Us")]), _c('br'), _vm._v("Our team is ready to help you."), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:855-904-0188"
    }
  }, [_vm._v("855-904-0188")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center invest-with-us-text"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("Email Us")]), _c('br'), _vm._v("We'll get back to you within 24 hours."), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/contact-us#contact-form"
    }
  }, [_vm._v("Drop us a line")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Investor_Customer_Voice.png"),
      "alt": "American Credit Investor Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("David Lee")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Owner, Beautiful Smile Dental")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text",
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("You work hard. We work hard. We share the same ethic.")]), _vm._v(" That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/contact-us"
    }
  }, [_vm._v("Feel free to contact us "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png"),
      "alt": "American Credit Business loans the Difference You can Trust"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06bc47c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ.vue
// module id = 1938
// module chunks = 5